import React from "react";
import { Loader2 } from "lucide-react";
import { useRecruitment } from "../../hooks/useRecruitment";

export const RecruitmentList = () => {
  const applicants = useRecruitment();

  return (
    <div>
      <h2 className="font-display font-extrabold text-2xl tracking-tight mb-6">Team applications</h2>
      <div className="bg-white rounded-2xl border border-[#E5E7EB] overflow-hidden">
        {!applicants ? (
          <div className="p-16 flex justify-center"><Loader2 className="animate-spin text-[#052F24]/40" /></div>
        ) : applicants.length === 0 ? (
          <div className="p-16 text-center text-[#6B7280]" data-testid="recruitment-empty-state">No applications yet.</div>
        ) : (
          <table className="w-full text-sm" data-testid="recruitment-table">
            <thead>
              <tr className="bg-[#F9FAFB] text-left text-[11px] font-bold tracking-[0.12em] uppercase text-[#6B7280]">
                <th className="px-5 py-4">Name</th>
                <th className="px-5 py-4">Mobile</th>
                <th className="px-5 py-4">Email</th>
                <th className="px-5 py-4">Applied</th>
              </tr>
            </thead>
            <tbody>
              {applicants.map((a) => (
                <tr key={a.id} className="border-t border-[#E5E7EB]" data-testid={`recruitment-row-${a.id}`}>
                  <td className="px-5 py-4 font-semibold">{a.name}</td>
                  <td className="px-5 py-4 text-[#6B7280]">{a.mobile}</td>
                  <td className="px-5 py-4 text-[#6B7280]">{a.email}</td>
                  <td className="px-5 py-4 text-[#6B7280]">{new Date(a.created_at).toLocaleDateString("en-GB")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};
